import $ from 'jquery';

function PlaceholderText(element) {
  this.element = element;
  this.$element = $(element);
  this.convertLabelToPlaceholderText();
}

PlaceholderText.prototype = {
  convertLabelToPlaceholderText() {
    const text = this.$element.find('label').text().replace(':', '');
    if (!text.length) return;
    this.$element.find('input').attr('placeholder', text);
  },
};

export default PlaceholderText;



// WEBPACK FOOTER //
// ./PlaceholderText.js